import React, { forwardRef, ReactElement } from "react";
import { TableRowProps, Tr as ChakraTr } from "@chakra-ui/react";
import { Consumer } from "./Provider";

interface ITrInnerProps extends TableRowProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers?: Record<number, any>;
  inHeader?: boolean;
}

const TrInnerComponent: React.ForwardRefRenderFunction<
  HTMLTableRowElement,
  ITrInnerProps
> = (props: ITrInnerProps, ref) => {
  const { headers, children, inHeader, ...rest } = props;

  if (headers && inHeader) {
    React.Children.map(props.children, (child, i) => {
      if (child) {
        headers[i] = (child as ReactElement).props.children;
      }
    });
  }

  const childProps = (idx: number) =>
    inHeader ? { key: idx } : { key: idx, columnKey: idx };

  return (
    <ChakraTr ref={ref} {...rest}>
      {children &&
        React.Children.map(
          children,
          (child, idx) =>
            React.isValidElement(child) &&
            React.cloneElement(child, childProps(idx))
        )}
    </ChakraTr>
  );
};

const TrInner = forwardRef(TrInnerComponent);

export type ITrProps = Omit<ITrInnerProps, "headers">;

const TrComponent: React.ForwardRefRenderFunction<
  HTMLTableRowElement,
  ITrProps
> = (props: ITrProps, ref) => (
  <Consumer>
    {(headers) => <TrInner ref={ref} {...props} headers={headers} />}
  </Consumer>
);

export const Tr = forwardRef(TrComponent);
